import { GAPI_CLIENT_ID, GAPI_SCOPES } from '../config';
import { isExpired, decodeToken } from 'react-jwt';
import { setGoogleTokens } from '../lib/axios';

export const GOOGLE_USER_INFO_START = 'GOOGLE_USER_INFO_START';
export const GOOGLE_USER_INFO_SUCCESS = 'GOOGLE_USER_INFO_SUCCESS';
export const GOOGLE_LOGIN_START = 'GOOGLE_LOGIN_START';
export const GOOGLE_LOGIN_SUCCESS = 'GOOGLE_LOGIN_SUCCESS';
export const GOOGLE_LOGIN_ERROR = 'GOOGLE_LOGIN_ERROR';

export const requestAccessToken = () => {
    return async (dispatch, getState) => {
        dispatch({
            type: GOOGLE_USER_INFO_START,
        });
        const id_token = getState().googleAuth.userInfo.id_token;
        const userInfo = decodeToken(id_token);
        const client = window.google.accounts.oauth2.initTokenClient({
            client_id: GAPI_CLIENT_ID,
            scope: GAPI_SCOPES,
            prompt: '',
            hint: userInfo.sub,
            callback: async (tokenResponse) => {
                if (tokenResponse && tokenResponse.access_token) {
                    const scopeList = GAPI_SCOPES.split(' ');

                    const grantedScopes = window.google.accounts.oauth2.hasGrantedAllScopes(tokenResponse, ...scopeList);

                    const user = {
                        email: userInfo.email,
                        givenName: userInfo.given_name,
                        familyName: userInfo.family_name,
                        grantedScopes,
                        id_token,
                        id: userInfo.sub,
                        access_token: tokenResponse.access_token,
                    };
                    sessionStorage.setItem('googleUserInfo', JSON.stringify(user));
                    setGoogleTokens(id_token, user.access_token);
                    dispatch({
                        type: GOOGLE_USER_INFO_SUCCESS,
                        payload: user,
                    });
                } else {
                    dispatch({
                        type: GOOGLE_LOGIN_ERROR,
                    });
                }
            },
            error_callback: (error) => {
                console.error(error);
                dispatch({
                    type: GOOGLE_LOGIN_ERROR,
                });
            },
        });
        client.requestAccessToken();
    };
};

export function resumeGoogleLogin(selectAccount) {
    return async (dispatch) => {
        if (selectAccount) {
            sessionStorage.removeItem('googleToken');
            sessionStorage.removeItem('googleUserInfo');
        }

        dispatch({ type: GOOGLE_LOGIN_START });
        const googleToken = sessionStorage.getItem('googleToken');
        if (googleToken && !isExpired(googleToken)) {
            const userInfo = sessionStorage.getItem('googleUserInfo');
            if (userInfo) {
                const googleUserInfo = JSON.parse(userInfo);
                window.gapi.client.setToken({
                    access_token: googleUserInfo.access_token,
                });
                setGoogleTokens(googleToken, googleUserInfo.access_token);
                dispatch({
                    type: GOOGLE_USER_INFO_SUCCESS,
                    payload: googleUserInfo,
                });
            } else {
                dispatch({
                    type: GOOGLE_LOGIN_SUCCESS,
                    payload: {
                        id_token: googleToken,
                    },
                });
            }
        } else {
            try {
                window.google.accounts.id.initialize({
                    client_id: GAPI_CLIENT_ID,
                    auto_select: !selectAccount,
                    callback: async (userInfo) => {
                        sessionStorage.setItem('googleToken', userInfo.credential);
                        dispatch({
                            type: GOOGLE_LOGIN_SUCCESS,
                            payload: {
                                id_token: userInfo.credential,
                            },
                        });
                    },
                });
                window.google.accounts.id.prompt();
            } catch {
                dispatch({ type: GOOGLE_LOGIN_ERROR });
            }
        }
    };
}

export function resumeGoogleAddOnLogin(googleIdToken, googleAccessToken) {
    setGoogleTokens(googleIdToken, googleAccessToken);
    const userInfo = decodeToken(googleIdToken);

    const user = {
        email: userInfo.email,
        givenName: userInfo.given_name || '',
        familyName: userInfo.family_name || '',
        id_token: googleIdToken,
        id: userInfo.sub,
        access_token: googleAccessToken,
    };

    return async (dispatch) => {
        dispatch({
            type: GOOGLE_USER_INFO_SUCCESS,
            payload: {
                ...user,
            },
        });
    };
}
